import type { Vertical } from '$lib/types';

// The Hotels vertical is identified by its seeded slug 'hotels' (see
// defaultVerticals in internal/database/seed.go) rather than a hardcoded id,
// since vertical ids vary by environment/seed order. Used to switch the
// people form/list between the generic company picker and the
// hotel/brand/group hierarchy pickers (see PeoplePage.svelte).
export function isHotelsVertical(
  verticalId: number | undefined,
  verticals: Vertical[] | undefined
): boolean {
  if (verticalId === undefined || !verticals) return false;
  return verticals.find((v) => v.id === verticalId)?.slug === 'hotels';
}
